import { defineMessages } from "react-intl";
import { validator } from "lib/build/forms/ltx/phase-i/medical-history/indicationForLiverTransplantation";
import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	indicationForLiverTransplantation: {
		id: "form.indication_for_liver_transplantation",
		defaultMessage: "Májtranszplantációt indokló diagnózis"
	},
	comment: {
		id: "form.indication_for_liver_transplantation.comment",
		defaultMessage: "Megjegyzés"
	}
});

const fields: { [key: string]: FieldData } = {
	comment: {
		type: "field",
		path: ["comment"],
		label: messages.comment,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.comment }] }]
};

export const node: LeafNode = {
	id: "indicationForLiverTransplantation",
	value: {
		title: messages.indicationForLiverTransplantation,
		validator,
		fieldset,
		applyCurrentDate: true
	}
};
